import React from 'react';
import { withNamespaces } from 'react-i18next';

class Lauren extends React.Component {
    render() {
        return (
            <div className="homePageContainer">
                <div className="homeText">
                    <div className="homeTextInnerWrapper">
                        <div className="homeTextInner">
                            <div className="homeTextActualText">
                            <h2>Lauren Hill Academy</h2>
                                <div className="detailsHeader">
                                <div className="subBlock1">
                                    
                                    <h3>{this.props.t("Statistics")}</h3>
                                    <p>{this.props.t("Number of teachers")} 80</p>
                                    <p>{this.props.t("Number of students")} 1200</p>
                                    <p>{this.props.t("International students")} 8%</p>
                                    <p>{this.props.t("School uniform")} {this.props.t("Required")}</p>
                                    <p>{this.props.t("Grades")} {this.props.t("9-11-1")}</p>
                                    <p>{this.props.t("Founded")} 1969</p>
                                </div>
                                <div className="subBlock2">
                                <img src="/images/lauren2.jpg" alt="city" />
                                <img src="/images/lauren1.jpg" alt="city" />
                                </div>
                                </div>

                                <div className="schoolDetailsBlock">
                                    <h2>{this.props.t("Programs")}</h2>
                                    <span>{this.props.t("Enriched English, Math, Science, Fine Arts (Dance, Instrumental Music, Art, Drama), Advanced Computer Applications.")}</span>
                                </div>
                                <div className="schoolDetailsBlock">
                                    <h2>{this.props.t("Sports Activities")}</h2>
                                    <span>{this.props.t("Basketball, Volleyball, Soccer, Badminton, Wrestling, Swimming, Hockey.")}</span>
                                </div>
                                <div className="schoolDetailsBlock">
                                    <h2>{this.props.t("Club Activities")}</h2>
                                    <span>{this.props.t("Jazz Band, Radio Station, Robotics Club, Leadership Club, Student Council After School Dance Program, Yearbook, Athletics Council.")}</span>
                                </div>
              
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default withNamespaces()(Lauren);